import { render, staticRenderFns } from "./shuttleBox.vue?vue&type=template&id=37ca2f97&scoped=true&"
import script from "./shuttleBox.vue?vue&type=script&lang=ts&"
export * from "./shuttleBox.vue?vue&type=script&lang=ts&"
import style1 from "./shuttleBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca2f97",
  null
  
)

export default component.exports